<script setup>
import webpImage from '@/assets/1px.webp';
import { ref } from 'vue';
import { useMainStore } from '@/store';

const isWebpDetectionComplete = ref(false);

const handleImageError = () => {
    const store = useMainStore();
    store.webpSupported = false;

    isWebpDetectionComplete.value = true;
};
const handleImageLoad = () => {
    const store = useMainStore();
    store.webpSupported = true;

    isWebpDetectionComplete.value = true;
};
</script>

<template>
  <img
    v-if="!isWebpDetectionComplete"
    :src="webpImage"
    class="webp-detector-container"
    @error="handleImageError"
    @load="handleImageLoad"
  >
</template>

<style scoped>
.webp-detector-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
}
</style>
